import "core-js/modules/es6.array.map.js";
import TitleSection from '~/components/atoms/Editorial/TitleSection.vue';
import SubtitleSection from '~/components/atoms/Editorial/SubtitleSection.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import GenericFaq from '~/components/molecules/Editorial/Global/GenericFaq.vue';
export default {
  name: 'Faq',
  components: {
    TitleSection: TitleSection,
    SubtitleSection: SubtitleSection,
    SimpleParagraph: SimpleParagraph,
    GenericFaq: GenericFaq
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isOpen: null
    };
  },
  computed: {
    title: function title() {
      return this.payload.primary.title[0] || {};
    },
    subtitle: function subtitle() {
      return this.payload.primary.subtitle[0] || {};
    },
    paragraph: function paragraph() {
      return this.payload.primary.paragraph || [];
    },
    faq: function faq() {
      return this.payload.items.map(function (item) {
        return {
          question: item.question[0].text || '',
          answer: item.answer || []
        };
      });
    }
  },
  methods: {
    toggleFaq: function toggleFaq(index) {
      this.isOpen = this.isOpen === index ? null : index;
    }
  }
};